import React from 'react';
import { Box, Typography } from '@mui/material';
import { ChevronDown, ChevronUp } from 'lucide-react';
import i18n from "i18next";
export default i18n;

// Readable: "Mon 15 Jan, 14:30" or "Mon 15 Jan, 14:30 – 16:00"
export const formatTimeRange = (from, to) => {
  if (!from) return null;

  const localeMap = {
    en: "en-US",
    fr: "fr-FR",
    fi: "fi-FI",
  };

  const locale =
    localeMap[i18n.language] || i18n.language || "fi-FI";
  
  const fmt = (ts) => new Date(ts).toLocaleString(locale, {
    weekday: 'short', day: 'numeric', month: 'short',
    hour: '2-digit', minute: '2-digit',
  });
  const fmtTimeOnly = (ts) => new Date(ts).toLocaleString(locale, {
    hour: '2-digit', minute: '2-digit',
  });

  if (!to) return fmt(from);

  // If same day — show date once, just append end time
  const fromDate = new Date(from).toDateString();
  const toDate   = new Date(to).toDateString();
  return fromDate === toDate
    ? `${fmt(from)} – ${fmtTimeOnly(to)}`
    : `${fmt(from)} – ${fmt(to)}`;
};

export const SectionHeader = ({
  icon,
  title,
  subtitle,
  timeDisplay,
  expanded,
  onToggle,
  inModal = false,
  color = 'primary',
}) => (
  <Box
    sx={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      cursor: 'pointer', py: 1.25, px: inModal ? 0 : 1.5, borderRadius: 1.5,
      '&:hover': { bgcolor: 'action.hover' },
      transition: 'background-color 0.15s',
    }}
    onClick={onToggle}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      {/* Icon bubble */}
      <Box sx={{
        width: 36, height: 36, borderRadius: '50%',
        bgcolor: `${color}.50`, border: '1.5px solid',
        borderColor: `${color}.100`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
      }}>
        {icon}
      </Box>

      <Box>
        <Typography variant="subtitle2" fontWeight={700} lineHeight={1.2}>
          {title}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap', mt: 0.25 }}>
          {subtitle && (
            <Typography variant="caption" color="text.secondary" noWrap sx={{ maxWidth: 220 }}>
              {subtitle}
            </Typography>
          )}
          {subtitle && timeDisplay && (
            <Typography variant="caption" color="text.disabled">·</Typography>
          )}
          {timeDisplay && (
            <Typography variant="caption" color="text.secondary">
              {timeDisplay}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>

    <Box sx={{
      width: 28, height: 28, borderRadius: '50%',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      bgcolor: expanded ? 'action.selected' : 'transparent',
      transition: 'background-color 0.15s',
      flexShrink: 0,
    }}>
      {expanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
    </Box>
  </Box>
);